<div
  class="h-8 gap-4 z-10 w-full bottom-0 bg-gray-100 text-gray-400 flex items-center px-6 text-xs font-light"
>
  <span (dblclick)="openDocumentation()">{{ getVersion() }}</span>

  @if (getEnvType() !== 'production') {
    <span>{{ getEnvType() }}</span>
  }

  <div class="flex-grow">Copyright &copy; {{ currentYear }} pacemaker.ai</div>
  <div>
    <ul
      class="p-0 *:inline *:p-2 *:cursor-pointer *:transition-all *:duration-300"
    >
      <li (click)="openPrivacyPolicy()">
        {{ 'FOOTER.PRIVACY' | translate }}
      </li>
      <li (click)="openImprint()">
        {{ 'FOOTER.IMPRINT' | translate }}
      </li>
    </ul>
  </div>
</div>
